import { BodyText } from '@utilitywarehouse/hearth-react';

import { MobileTariffType } from '@generated/gql/graphql';

const simTileContents = {
  [MobileTariffType.EssentialMax]: {
    name: 'Essential Max',
    benefits: [
      {
        id: '10gb',
        content: (
          <BodyText>
            <b>10GB</b> monthly data
          </BodyText>
        ),
      },
      {
        id: 'unlimited',
        content: (
          <BodyText>
            <b>Unlimited</b> UK minutes and texts
          </BodyText>
        ),
      },
      {
        id: '4g',
        content: (
          <BodyText>
            <b>4G</b> and Wi-Fi calling
          </BodyText>
        ),
      },
      {
        id: 'EU-roaming',
        content: (
          <BodyText>
            Inclusive <b>EU roaming</b>
          </BodyText>
        ),
      },
      {
        id: 'limited',
        content: (
          <BodyText>
            <b>Limited time</b> offer
          </BodyText>
        ),
      },
    ],
  },
  [MobileTariffType.UnlimitedMax]: {
    name: 'Unlimited Max',
    benefits: [
      {
        id: 'Unlimited',
        content: (
          <BodyText>
            <b>Unlimited</b> monthly data
          </BodyText>
        ),
      },
      {
        id: 'Unlimited-minutes',
        content: (
          <BodyText>
            <b>Unlimited</b> UK minutes and texts
          </BodyText>
        ),
      },
      {
        id: '5G-4G',
        content: (
          <BodyText>
            <b>5G, 4G</b> and Wi-Fi calling
          </BodyText>
        ),
      },
      {
        id: 'EU-roaming',
        content: (
          <BodyText>
            Inclusive <b>EU roaming</b>
          </BodyText>
        ),
      },
      {
        id: 'limited',
        content: (
          <BodyText>
            <b>Limited time</b> offer
          </BodyText>
        ),
      },
    ],
  },
  [MobileTariffType.GoEssential]: {
    name: 'Go Essential',
    benefits: [
      {
        id: '10gb',
        content: (
          <BodyText>
            <b>10GB</b> monthly data
          </BodyText>
        ),
      },
      {
        id: 'unlimited',
        content: (
          <BodyText>
            <b>Unlimited</b> UK minutes and texts
          </BodyText>
        ),
      },
      {
        id: '5G-4G',
        content: (
          <BodyText>
            <b>5G, 4G</b> and Wi-Fi calling
          </BodyText>
        ),
      },
      {
        id: 'EU-roaming',
        content: (
          <BodyText>
            Inclusive <b>EU roaming</b>
          </BodyText>
        ),
      },
    ],
  },
  [MobileTariffType.GoUnlimited]: {
    name: 'Go Unlimited',
    benefits: [
      {
        id: 'Unlimited',
        content: (
          <BodyText>
            <b>Unlimited</b> monthly data
          </BodyText>
        ),
      },
      {
        id: 'Unlimited-minutes',
        content: (
          <BodyText>
            <b>Unlimited</b> UK minutes and texts
          </BodyText>
        ),
      },
      {
        id: '5G-4G',
        content: (
          <BodyText>
            <b>5G, 4G</b> and Wi-Fi calling
          </BodyText>
        ),
      },
      {
        id: 'EU-roaming',
        content: (
          <BodyText>
            Inclusive <b>EU roaming</b>
          </BodyText>
        ),
      },
    ],
  },
};

export { simTileContents };
